import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexTagPills',
  setup(__props) {

const BadgesContextual = defineAsyncComponent(() => import("@/components/theme/uikits/tag&pills/BadgesContextual.vue"))
const PillsContextual = defineAsyncComponent(() => import("@/components/theme/uikits/tag&pills/PillsContextual.vue"))
const NumberBadge = defineAsyncComponent(() => import("@/components/theme/uikits/tag&pills/NumberBadge.vue"))
const TagsIcons = defineAsyncComponent(() => import("@/components/theme/uikits/tag&pills/TagsIcons.vue"))
const TagsSection = defineAsyncComponent(() => import("@/components/theme/uikits/tag&pills/TagsSection.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Ui Kits",
      mains: "Tag pills",
      title: "Tag pills"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(BadgesContextual)),
        _createVNode(_unref(PillsContextual)),
        _createVNode(_unref(NumberBadge)),
        _createVNode(_unref(TagsIcons)),
        _createVNode(_unref(TagsSection))
      ])
    ])
  ], 64))
}
}

})